import { Container, Stack } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import HeaderContainer from "../views/Header";
import Footer from "./Footer";

type LayoutProps = {
  behavior?: "signin" | "dashboard" | "chatbot" | "docs" | "confirm_email" | "maintenance"
  showFooter?: boolean
} & PropsWithChildren

export const Layout: React.FC<LayoutProps> = ({ children, behavior, showFooter }) => {
  return (
    <Stack>
      <HeaderContainer behavior={behavior} />
      <Container display='flex' flexDirection='column' gap={6} px="9">
        {children}
      </Container>
      {showFooter && <Footer />}
    </Stack>
  )
}
